// Familias reales y alianzas matrimoniales (`diplomacy.dynasty`) — español.
// Se une en ./messages.ts.

export const gameDynastyEs = {
  'dynasty.court': 'Corte real',
  'dynasty.princess': 'Princesa',
  'dynasty.prince': 'Príncipe',
  'dynasty.ofHouse': '{rank} de {house}',
  'dynasty.home': 'En la corte',
  'dynasty.wed': 'Casado con {spouse}',
  'dynasty.travelling': 'De camino a {house}',
  'dynasty.held': 'Retenido por {captor}',
  'dynasty.dead': 'Muerto',
  'dynasty.propose': 'Proponer matrimonio',
  'dynasty.pending': 'Propuesta enviada',
  'dynasty.incoming': 'Propuesta pendiente',
  'dynasty.bonded': 'Unidos por matrimonio',
  'dynasty.atPact': 'En pacto',
  'dynasty.needAlliance': 'El matrimonio requiere un pacto o una alianza',
  'dynasty.offerTitle': '{house} ofrece un matrimonio',
  'dynasty.offerBody': 'Su {theirs} por tu {yours}: un lazo que refuerza la alianza.',
  'dynasty.accept': 'Aceptar',
  'dynasty.decline': 'Rechazar',
  'dynasty.stage.child': 'Niñez',
  'dynasty.stage.young': 'Juventud',
  'dynasty.stage.middle': 'Madurez',
  'dynasty.stage.old': 'Vejez',
  'dynasty.mourning': 'La casa {house} llora a su cabeza: la línea pasa',
} as const;
